export const aboutText = [
  `

את הצבעים הנראים לעין אפשר לייצג באמצעות שילוב של שלושה צבעי יסוד : אדום, ירוק וכחול. ייצוג כזה, הקרוי RGB, הוא הייצוג המקובל בעולם המחשבים, והוא נוח לשימוש במצלמות ובמסכים. אולם ציירים ומעצבים מתקשים להשתמש בייצוג מספרי לשם בחירת צבע. מפתחי אפליקציות בשנות השבעים חיפשו דרכים לאפשר בחירת צבעים וגוונים באופן ויזואלי. באחת השיטות, הקרויה HSB או HSV, הצבע נבחר באמצעות סימון נקודה במעגל-צבעים.
הצבע (HUE) נקבע לפי הזווית ביחס לאדום, והרוויה (Saturation), שהיא מידת הערבוב עם הלבן  נקבעת לפי המרחק ממרכז המעגל, כאשר הערך 1 מייצג צבע רווי, ללא כל ערבוב עם לבן.
`,
  `
לפורמט דומה ל- HSB נמצא שימוש ביצירת אפקטים מעניינים בתמונות, כמו פילטרים הדומים לאלו שיש באינסטגרם. למשל, בשימוש בתוכנת CSS המשמשת לעיצוב דפים ברשת, הפונקציה (hue_rotate(20deg משנה את כל הצבעים בתמונה על ידי 'הזזתם' ב-20 מעלות, והפונקציה  saturate(85%) מקטינה את הסטורציה של כל צבע ב-15% על ידי ערבובו עם לבן. זהו אחד משלל האפקטים המשמשים לאמולציה של הפילטר Aden באינסטגרם. 
`,
  `
באפליקציה זו תוכלו לראות, כיצד משפיעות הפונקציות hue_rotate ו-saturate, וכן מידת בהירות (brightness), על התמונה המתקבלת.
`,
];
